var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoInterviewProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 348.46,
    height: 193.737,
    viewBox: "0 0 348.46 193.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#040227;}.b{fill:#fff;}.c{fill:#e3e4f1;}.d{fill:#c5c9f6;}.e{fill:#5066e7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-843.906 -3781.263)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(843.906 3781.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.614,0H277.927a6.615,6.615,0,0,1,6.615,6.615v170.8a6.614,6.614,0,0,1-6.614,6.614H6.614A6.614,6.614,0,0,1,0,177.413V6.614A6.614,6.614,0,0,1,6.614,0Z",
    transform: "translate(31.959)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 261.288,
    height: 164.024,
    transform: "translate(43.586 10.002)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 261.288,
    height: 164.024,
    transform: "translate(43.586 10.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M321.918,415.248a9.945,9.945,0,0,0,9.9,9.568H660.475a9.945,9.945,0,0,0,9.9-9.568Z",
    transform: "translate(-321.918 -231.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H271.251V.753H0Z",
    transform: "translate(38.605 183.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M495.353,239.044A2.548,2.548,0,1,1,497.9,236.5,2.551,2.551,0,0,1,495.353,239.044Zm0-4.342a1.794,1.794,0,1,0,1.794,1.794A1.8,1.8,0,0,0,495.353,234.7Z",
    transform: "translate(-321.123 -231.923)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 63.277,
    cy: 63.278,
    rx: 63.277,
    ry: 63.278,
    transform: "translate(954.857 3814.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M60.275,30.434V12.772c0-2.778-1.846-5.037-4.1-5.037H6.355c-2.258,0-4.1,2.26-4.1,5.037V63.208c0,2.778,1.846,5.058,4.1,5.058H56.17c2.258,0,4.1-2.28,4.1-5.037V45.566L76.1,65.737V10.263Z",
    transform: "translate(978.961 3840.131)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoInterviewProfile);
export default __webpack_public_path__ + "static/media/video-interview-profile.a18c05e63e6760f1eb928cff9d1a82f1.svg";
export { ForwardRef as ReactComponent };